import React, { useState, useEffect, Fragment, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import FileDownload from 'js-file-download'
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import common_en from "../../translations/en/common.json"
import common_de from "../../translations/de/common.json"
import common_nl from "../../translations/nl/common.json"
import { useDispatch } from "react-redux";
import { loginStatus } from "../../actions/userActions";
import { Modal, Tabs, Tab } from "react-bootstrap";
import { Bars } from "react-loader-spinner";
import SelectWithErrors from "../../components/Basic/Select/SelectWithErrors";
import UnityLoader from "../WebGL/UnityLoader";
import footballField from "../../data/pitch.png"
import "./canvas.css"

i18n
  .use(initReactI18next)
  .init({
    interpolation: { escapeValue: false },  // React already does escaping
    lng: 'en',                              // language to use
    resources: {
      en: {
        common: common_en
      },
      de: {
        common: common_de
      },
      nl: {
        common: common_nl
      }
    },
  });

var pp = false
let listTeamA = []
let listTeamB = []

const EditScenarios = () => {
  const { t } = useTranslation('common')
  const { id } = useParams()
  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  const uid = userInfo !== null ? userInfo.user_id : null
  const token = userInfo !== null ? userInfo.token : null
  const history = useHistory()
  const dispatch = useDispatch()

  const [form, setForm] = useState({
    name: "",
    folder_id: 30,
    favorite: false,
    source: "",
    scenarioType: "",
    startTime: "",
    endTime: "",
    description: "",
    tags: null
  });

  const [folders, setFolders] = useState([]);
  const [scenario, setScenario] = useState();
  const [tags, setTags] = useState([]);
  const [ea5File, setEa5File] = useState();
  const [imageFile, setImageFile] = useState()
  const [deleteConfirmation, setDeleteConfirmation] = useState(false)
  const [sourceFile, setSourceFile] = useState()
  const [metaFile, setMetaFile] = useState()
  const [eventFile, setEventFile] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState([])

  const [teamA, setTeamA] = useState({})
  const [teamB, setTeamB] = useState({})
  const [ball, setBall] = useState({})
  const [frameNumber, setFrameNumber] = useState(0)
  const [frameLength, setFrameLength] = useState([])
  const [pause, setPause] = useState(false)
  const [activeFrameButton, setActiveFrameButton] = useState({ 'button_0': true })
  const [length, setLength] = useState(56)
  const [henti, setHenti] = useState(false)
  const [stageHeight, setStageHeight] = useState(0)
  const [stageWidth, setStageWidth] = useState(0)
  const [isDrag, setIsDrag] = useState(false)
  let parentFolder = []

  const [timeStamps, setTimeStamps] = useState({ minutes: 0, second: 0 })
  const [startTime, setStartTime] = useState({ minutes: "", seconds: "" })
  const [endTime, setEndTime] = useState({ minutes: "", seconds: "" })

  const configJson = {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  }

  const stageRef = useRef(null);
  const [activeTab, setActiveTab] = useState('preview');

  /* useEffect(() => {
    if (activeTab === '2d') {
      setTimeout(() => {
        fitStage();
      }, 100);
    }
  }, [activeTab]); */

  const stopInputPropagation = (e) => {
    e.stopPropagation();
    if (e.nativeEvent) {
      e.nativeEvent.stopImmediatePropagation();
    }
  };

  const uploadFile = async (e) => {
    if (e.target.files && e.target.files.length === 1) {
      if (e.target.name === "meta") {
        setMetaFile(e.target.files[0])
      } else if (e.target.name === "event") {
        setEventFile(e.target.files[0])
      } else {
        if (form.source === "saivavt") {
          getSaivaVTLength(e)
        } else if (form.source === "ea5") {
          getEa5Length(e)
        } else if (form.source === "metrica") {
          getMetricaLength(e)
        }
        setSourceFile(e.target.files[0])
      }
    }
  }

  const getEa5Length = (e) => {
    e.preventDefault()
    const reader = new FileReader()
    reader.onload = async (e) => {
      const text = (e.target.result)
      const fileLength = JSON.parse(text).sceneCount
      setTimeStamps({ minutes: padTo2Digits(Math.floor(fileLength / 60)), second: padTo2Digits(fileLength % 60) })
    }
    reader.readAsText(e.target.files[0])
  }

  const getMetricaLength = (e) => {
    e.preventDefault()
    const reader = new FileReader()
    reader.onload = async (e) => {
      const text = (e.target.result)
      const rowCount = text.split('\n')
      const fileLength = Math.round((rowCount.length - 1) / 25)
      setTimeStamps({ minutes: padTo2Digits(Math.floor(fileLength / 60)), second: padTo2Digits(fileLength % 60) })
    };
    reader.readAsText(e.target.files[0])
  }

  const getSaivaVTLength = (e) => {
    e.preventDefault()
    const reader = new FileReader()
    reader.onload = async (e) => {
      const text = (e.target.result)
      const fileLength = (JSON.parse(text).Players[0].maxFrameNumber) / 5
      setTimeStamps({ minutes: padTo2Digits(Math.floor(fileLength / 60)), second: padTo2Digits(fileLength % 60) })
    };
    reader.readAsText(e.target.files[0])
  }



  useEffect(() => {
    const getFolders = async () => {
      try {
        const folders = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/scenarios/folder/user/${uid}`,
          configJson
        );

        folders.data.map(folder => {
          if (folder.parent_id === 0) {
            parentFolder.push(folder)
          }
        })

        folders.data.map(folder => {
          if (folder.parent_id !== 0) {
            parentFolder.map(parent => {
              if (parent.folder_id === folder.parent_id) {
                folder.name = `${parent.name}/${folder.name}`
                return folder
              }
            })
          } else {
            return folder
          }
        })
        setFolders(folders.data);
      } catch (error) {
        if (error.response.status === 401) {
          dispatch(loginStatus())
        }
      }
    };

    const getScenario = async () => {
      const scenario = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/scenarios/${id}`, configJson)
      setForm(scenario.data)
      scenario.data.tags ? setTags(scenario.data.tags.split(",")) : ""
      setStartTime({ minutes: padTo2Digits(scenario.data.startTime === "NaN" ? 0 : Math.floor(parseInt(scenario.data.startTime) / 60)), seconds: padTo2Digits(scenario.data.startTime === "NaN" ? 0 : parseInt(scenario.data.startTime) % 60) })
      setEndTime({ minutes: padTo2Digits(scenario.data.startTime === "NaN" ? 0 : Math.floor(parseInt(scenario.data.endTime) / 60)), seconds: padTo2Digits(scenario.data.endTime === "NaN" ? 0 : parseInt(scenario.data.endTime) % 60) })
    }

    const fetchScenarioDetails = async () => {
      const scenarios = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/scenarios/get?id=${id}`, configJson)

      const tempA = scenarios.data.sceneObjects.filter(obj => {
        if (obj.team) {
          return obj.team === 2
        }

        if (obj.shirt) {
          return obj.shirt === 2
        }

      })

      const tempB = scenarios.data.sceneObjects.filter(obj => {
        if (obj.team) {
          return obj.team === 1
        }

        if (obj.shirt) {
          return obj.shirt === 1
        }

      })

      const ball = scenarios.data.sceneObjects.filter(obj => {
        return obj.id === 'ball'
      })

      setBall(ball)
      setFrameLength(Array(scenarios.data.info.sceneCount).fill(0))
      setTeamB(tempB)
      setTeamA(tempA)
    }

    getFolders();
    getScenario();
    fetchScenarioDetails();
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData()
    formData.append('name', form.name)
    formData.append('folder_id', form.folder_id)
    formData.append('favorite', form.favorite)
    formData.append('description', form.description)
    if (tags) {
      formData.append('tags', tags.toString())
    }

    const config = {
      headers: {
        'Content-Type': 'multiparf/form-data',
        Authorization: `Bearer ${token}`
      }
    }

    try {
      setIsLoading(true)
      const scenario = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/v1/scenarios/${id}`, formData, config)
      setIsLoading(false)
      history.push('/scenarios')
    } catch (error) {
      setIsLoading(false)
      setErrors(error.response.data)
    }
  };

  const onChange = (e) => {
    if (e.target.name === "favorite") {
      setForm({ ...form, favorite: !form.favorite });
      return
    }

    if (e.target.value === "saivavt" || e.target.value === 'metrica') {
      setForm({ ...form, [e.target.name]: e.target.value, scenarioType: 'match' });
      return
    }

    if (e.target.name !== "scenarioType" && e.target.value === "ea5") {
      setForm({ ...form, [e.target.name]: e.target.value, scenarioType: '0' });
      return
    }

    setForm({ ...form, [e.target.name]: e.target.value })
  };

  const downloadFile = async (type) => {
    await axios(
      {
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v1/scenarios/download/${id}?type=${type}`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        method: 'GET',
        data: type,
        responseType: 'blob'

      }).then(res => {
        if (type === 'process') {
          FileDownload(res.data, `${form.name}_process.ea5`)
        } else if (type === 'match') {
          FileDownload(res.data, `${form.name}.json`)
        } else {
          FileDownload(res.data, `${form.name}.ea5`)
        }
      })
  }



  const deleteScenarioConfirmation = async () => {
    setDeleteConfirmation(true)
  }

  const deleteScenario = async () => {
    const scenario = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/v1/scenarios/${id}`, configJson)
    history.push('/scenarios')
  }

  Fancybox.bind("[data-fancybox]", {

  });

  const reverseConvert = (x, y, dim_x, dim_y) => {
    const xmin_A = 52.5
    const xmax_A = -52.5
    const ymin_A = -34
    const ymax_A = 34

    const xmin_B = 0
    const xmax_B = dim_x
    const ymin_B = dim_y
    const ymax_B = 0

    const x_range_A = xmax_A - xmin_A
    const x_range_B = xmax_B - xmin_B

    //const converted_x = ((x - xmin_A) / x_range_A) * x_range_B + xmin_B
    const converted_x = (((x - xmin_B) / x_range_B) * x_range_A) + xmin_A

    const y_range_A = ymax_A - ymin_A
    const y_range_B = ymax_B - ymin_B

    //const converted_y = ((y - ymin_A) / y_range_A) * y_range_B + ymin_B
    const converted_y = (((y - ymin_B) / y_range_B) * y_range_A) + ymin_A

    return {
      x: converted_x,
      y: converted_y
    }
  }

  const convert_coordinate = (x, y, dim_x, dim_y) => {
    const xmin_A = 52.5
    const xmax_A = -52.5
    const ymin_A = -34
    const ymax_A = 34

    const xmin_B = 0
    const xmax_B = dim_x
    const ymin_B = dim_y
    const ymax_B = 0

    const x_range_A = xmax_A - xmin_A
    const x_range_B = xmax_B - xmin_B

    const converted_x = ((x - xmin_A) / x_range_A) * x_range_B + xmin_B

    const y_range_A = ymax_A - ymin_A
    const y_range_B = ymax_B - ymin_B

    const converted_y = ((y - ymin_A) / y_range_A) * y_range_B + ymin_B

    return {
      x: converted_x,
      y: converted_y
    }
  }



  function padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }



  // Canvas Konva
  var width = 1060
  var height = 706


  /* var layer = new Konva.Layer()

  useEffect(() => {
    stageRef.current = new Konva.Stage({
      container: 'konva-container',
      width: width,
      height: height,
    });

    listTeamA = []
    listTeamB = []

    setStageHeight(stageRef.current.height())
    setStageWidth(stageRef.current.width())

    // stage.container = 'konva-container'
    // stage.width = width
    // stage.height = height

    // Image API
    // var imageObj = new Image()
    // imageObj.onload = function () {
    //   var football = new Konva.Image({
    //     x: 0,
    //     y: 0,
    //     image: imageObj,
    //     width,
    //     height
    //   })

    //   layer.add(football)
    //   football.zIndex(0)
    // }
    // imageObj.src = footballField

    if (pause) { setHenti(true) }

    if (!_.isEmpty(teamA)) {
      let indexa = 0;

      teamA.map(team => {
        const converted = convert_coordinate(team.transitions[frameNumber].position.y, team.transitions[frameNumber].position.x, stageRef.current.width(), stageRef.current.height())

        window["teama_" + (indexa + 1)] = new Konva.Circle({
          x: converted.x,
          y: converted.y,
          radius: 7,
          fill: 'red',
          name: "teama_" + team,
          draggable: true,
          id: team.id,
          team: team.team
        });

        window["teamatext_" + (indexa + 1)] = new Konva.Text({
          x: converted.x,
          y: converted.y,
          text: "Indexa_" + indexa
        });

        listTeamA.push(window["teama_" + (indexa + 1)])
        layer.add(window["teama_" + (indexa + 1)])
        // layer.add(window["teamatext_" + (indexa + 1)])

        indexa++;
      })

      let indexb = 0

      teamB.map(team => {
        const converted = convert_coordinate(team.transitions[frameNumber].position.y, team.transitions[frameNumber].position.x, stageRef.current.width(), stageRef.current.height())
        window["teamb_" + (indexb + 1)] = new Konva.Circle({
          x: converted.x,
          y: converted.y,
          radius: 7,
          fill: 'blue',
          name: 'teamb_' + team,
          draggable: true,
          id: team.id,
          team: team.team
        });
        listTeamB.push(window['teamb_' + (indexb + 1)])
        layer.add(window["teamb_" + (indexb + 1)])

        indexb++;
      })

      const ball_converted = convert_coordinate(ball[0].transitions[frameNumber].position.y, ball[0].transitions[frameNumber].position.x, stageRef.current.width(), stageRef.current.height())

      window["ballTeam"] = new Konva.Circle({
        x: ball_converted.x,
        y: ball_converted.y,
        radius: 5,
        fill: 'white',
        name: 'ball',
        draggable: true
      })
      layer.add(ballTeam)
    }
    fitStage()
    stageRef.current.add(layer)

  }, [teamA, teamB, frameNumber, isDrag]) */



  /* const fitStage = () => {
    var container = document.querySelector('#stage-parent');

    if (container && stageRef.current) {
      var containerWidth = container.offsetWidth;

      if (containerWidth === 0) {
        containerWidth = window.innerWidth / 1.45
      }

      var scale = containerWidth / width;

      stageRef.current.width(width * scale);
      stageRef.current.height(height * scale);
      stageRef.current.scale({ x: scale, y: scale });
    }
  }

  useEffect(() => {
    fitStage()
    window.addEventListener('resize', fitStage)
  }, [teamA, teamB]) */

  const changeFrameNumber = (number, e) => {
    e.preventDefault()
    setActiveFrameButton({ [`button_${number}`]: true })
    setFrameNumber(number)
  }

  const pauseScenario = () => {
    pp = true
    setPause(true)
  }

  const [play, setPlay] = useState(false)

  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  const playScenario = async () => {
    let i = frameNumber

    pp = false

    while (i < frameLength.length && pp === false) {
      setActiveFrameButton({ [`button_${i}`]: true })
      setFrameNumber(i)
      await sleep(200)
      i++
    }

    if (i === 56) {
      setFrameNumber(0)
      setActiveFrameButton({ [`button_0`]: true })
    }
  }

  const getPosition = async () => {
    const iteam = listTeamA.map(item => {
      console.log(item.attrs.x)
      const converted = reverseConvert(item.attrs.x, item.attrs.y, stageWidth, stageHeight)
      return {
        x: converted.x,
        y: converted.y,
        id: item.attrs.id,
        team: item.attrs.team
      }
    })

    const itebm = listTeamB.map(item => {
      const converted = reverseConvert(item.attrs.x, item.attrs.y, stageWidth, stageHeight)
      return {
        x: converted.x,
        y: converted.y,
        id: item.attrs.id,
        team: item.attrs.team
      }
    })

    const ball = {
      x: window["ballTeam"].attrs.x,
      y: window["ballTeam"].attrs.y,
    }

    const res = {
      scenario_id: id,
      frame: frameNumber,
      teamA: iteam,
      teamB: itebm,
      ball,
    }

    const edit = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/scenarios/edit/${id}`, res, configJson)

    window.location.reload()
  }

  const goUnityAndReload = () => {
    window.location.assign(`/scenarios/edit/unity/${id}`);
  };

  return (
    <div className="container-fluid loaded" style={{ display: "block", position: "relative" }}>
      <div style={{ display: isLoading ? "block" : "none", position: "absolute", top: "29rem", left: "51.4rem", zIndex: 1, color: "#60a5fa" }}>
        <Bars
          height="80"
          width="80"
          color="#2563eb"
          ariaLabel="bars-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
        <p style={{ textAlign: "center", fontSize: "20px" }}>Processing....</p>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box">
            <div className="page-title-right">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">{t('ADMIN_HOME')}</Link>
                </li>
                <li className="breadcrumb-item active">{t('Scenarios')}</li>
              </ol>
            </div>
            <h4 className="page-title">{t('Scenarios')}</h4>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              {/* Context Bar */}
              <div className="d-flex align-items-center justify-content-between mb-3 p-2 border-bottom sticky-top bg-white" style={{ zIndex: 100 }}>
                <div className="d-flex align-items-center flex-grow-1 mr-3">
                  {/* Folder Select */}
                  <div className="position-relative" style={{ minWidth: '150px', maxWidth: '250px' }}>
                    <i className="fa fa-folder-open-o position-absolute text-muted" style={{ left: '10px', top: '50%', transform: 'translateY(-50%)', zIndex: 1 }}></i>
                    <select
                      className="form-control border-0 bg-light pl-4 py-1"
                      name="folder_id"
                      value={form.folder_id}
                      onChange={onChange}
                      onKeyDown={stopInputPropagation}
                      onKeyUp={stopInputPropagation}
                      onKeyPress={stopInputPropagation}
                      style={{ appearance: 'none', fontWeight: 500, fontSize: '0.9rem', height: 'auto' }}
                    >
                      <option value="0">{t('Root folder')}</option>
                      {folders.map(f => <option key={f.folder_id} value={f.folder_id}>{f.name}</option>)}
                    </select>
                  </div>

                  <span className="text-muted mx-2">/</span>

                  {/* Name Input */}
                  <div className="flex-grow-1 position-relative">
                    <input
                      type="text"
                      name="name"
                      value={form.name}
                      onChange={onChange}
                      onKeyDown={stopInputPropagation}
                      onKeyUp={stopInputPropagation}
                      onKeyPress={stopInputPropagation}
                      className="form-control border-0 font-weight-bold pl-0"
                      style={{ boxShadow: 'none', fontSize: '1.2rem', color: '#a22a29', background: 'transparent' }}
                      placeholder={t('Scenario Name')}
                    />
                    <i className="fa fa-pencil text-muted position-absolute" style={{ right: '0', top: '50%', transform: 'translateY(-50%)', fontSize: '0.8rem', opacity: 0.5 }}></i>
                  </div>
                </div>

                <div className="d-flex align-items-center">
                  {/* Favorite Toggle */}
                  <button
                    className="btn btn-link mr-2 p-1"
                    onClick={() => setForm(prev => ({ ...prev, favorite: !prev.favorite }))}
                    title={t('Favorite')}
                  >
                    <i className={`fa ${form.favorite ? 'fa-star' : 'fa-star-o'} fa-lg text-warning`}></i>
                  </button>

                  {/* Save Button */}
                  <button type="button" onClick={onSubmit} className="btn btn-hero mr-2 btn-sm" style={{ backgroundColor: '#a22a29', borderColor: '#a22a29' }}>
                    <i className="fa fa-floppy-o mr-1"></i> {t('Save')}
                  </button>

                  {/* Delete Button */}
                  <button onClick={deleteScenarioConfirmation} className="btn btn-outline-brick btn-sm">
                    <i className="fa fa-trash-o"></i>
                  </button>
                </div>
              </div>

              <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} id="scenario-tabs" className="border-bottom-0 studio-look-tabs">
                <Tab eventKey="preview" title={<span><i className="fa fa-play mr-1"></i> Preview</span>}>
                  <div className="studio-look-panel">
                    <div className="mt-3">
                      {form.vid_combine ? (
                        <div className="mb-3">
                          <video className="studio-video-player" controls>
                            <source src={form.vid_input} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      ) : (
                        <p className="text-muted">No preview video available.</p>
                      )}
                      <div className="card border-0">
                        <div className="card-body px-0">

                          <div className="form-group">
                            <label className="font-weight-bold">{t('Description')}</label>
                            <textarea
                              className="form-control"
                              rows="4"
                              name="description"
                              onChange={onChange}
                              onKeyDown={stopInputPropagation}
                              onKeyUp={stopInputPropagation}
                              onKeyPress={stopInputPropagation}
                              value={form.description}
                              placeholder="Add a description for this scenario..."
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="3d" title={<span><i className="fa fa-cube mr-1"></i> 3D</span>}>
                  <div className="studio-look-panel">
                    <div className="mt-3">
                      <UnityLoader embedded={true} />
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="2d" title={<span><i className="fa fa-th mr-1"></i> 2D</span>}>
                  <div className="studio-look-panel">
                    <div className="mt-3">
                      {form.vid_combine ? (
                        <div className="mb-3">
                          <video className="studio-video-player" controls>
                            <source src={form.vid_court} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      ) : (
                        <p className="text-muted">No 2D video available.</p>
                      )}
                      {/* <div style={{ display: "block" }} className="canvas">
                        <div style={{ width: "100%", marginBottom: "5px" }} id="stage-parent">
                          <div id="konva-container"></div>
                        </div>
                        <div style={{ width: "100%", marginBottom: "5px", gap: "10px" }} className="button-player">
                          <button onClick={playScenario} className="btn btn-studio"><i className="fa fa-play"></i> Play</button>
                          <button onClick={pauseScenario} className="btn btn-studio"><i className="fa fa-pause"></i> Pause</button>
                          <button className="btn btn-studio"><i className="fa fa-stop"></i> Stop</button>
                          <button style={{ width: "150px", backgroundColor: '#a22a29', borderColor: '#a22a29' }} onClick={getPosition} className="btn btn-hero float-right"><i className="fa fa-download"></i>Edit Scenario</button>
                        </div>
                        <div className="timeline-container mt-2">
                          {frameLength.length > 0 && frameLength.map((item, index) => (
                            <div
                              key={index}
                              className={`timeline-item ${activeFrameButton[`button_${index}`] ? 'active' : ''}`}
                              onClick={(e) => changeFrameNumber(index, e)}
                            >
                              {index + 1}
                            </div>
                          ))}
                        </div>
                      </div> */}
                    </div>
                  </div>
                </Tab>
                {userInfo && (userInfo.developer_mode === 1 || userInfo.pgid === 5) && (
                  <Tab eventKey="debug" title={<span><i className="fa fa-cogs mr-1"></i> Video Tracking</span>}>
                    <div className="studio-look-panel">
                      <div className="mt-3">
                        {form.vid_combine ? (
                          <div className="mb-3">
                            <video className="studio-video-player" controls>
                              <source src={form.vid_combine} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        ) : (
                          <p className="text-muted">No debug video available.</p>
                        )}
                      </div>
                    </div>
                  </Tab>
                )}
              </Tabs>
            </div>
          </div>
        </div>
      </div >
      <Modal
        size="md"
        show={deleteConfirmation}
        onHide={() => setDeleteConfirmation(false)}
      >
        <Modal.Header closeButton>
          <h4>Scenario</h4>
        </Modal.Header>
        <Modal.Body>
          <div className="row p-2">
            <div className="col-12">
              <h4 className="">Are you sure want to delete this Scenario ?</h4>
            </div>

          </div>
          <div className="row p-2">
            <button onClick={deleteScenario} className="btn btn-sm btn-success mr-2">Confirm</button>
            <button onClick={() => setDeleteConfirmation(false)} className="btn btn-sm btn-danger">Cancel</button>
          </div>
        </Modal.Body>
      </Modal>
    </div >
  );
};

export default EditScenarios;
